import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* eslint-disable react-hooks/exhaustive-deps */
import { BackdropLoader, Icon, InputWithIcon, SelectMenu } from '@livable/saas-react-components';
import { MenuItem, Paper, TextField, Typography } from '@mui/material';
import { formatISO } from 'date-fns';
import { toJS } from 'mobx';
import moment from 'moment';
import React, { useEffect, useState, useRef } from 'react';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import MonthRangeDatePicker from 'src/components/general/MonthRangeDatePicker';
import { billStatuses } from 'src/constants/utilities';
import { useStore } from 'src/stores';
import { monthNames } from 'src/utils/date';
import { useBatch } from 'src/utils/hooks';
import AddCustomBilling from './AddCustomBilling';
import ApplyBillingFull from './ApplyBillingFull';
import { reloadedStatus } from './ApplyBillingFull/archivedAllocationRefresh';
import Billing from './billing';
import PreviewCycleChargesModal from './PreviewCycleChargesModal';
import SkipBillModal from './SkipBillModal';
import useStyles from './styles';
import { SubmeterBillModal } from './SubmeterBillModal';
import { useVirtualizer } from '@tanstack/react-virtual';
const BillingTab = observer(() => {
  var _property$allocations, _property$allocations2, _property$allocations3, _property$allocations4, _property$allocations5, _property$allocations6, _filteredBillings$len, _currentCompany$billi, _currentCompany$billi2, _currentCompany$billi3, _currentCompany$billi5, _currentCompany$billi6, _currentCompany$billi7, _currentCompany$billi8, _currentCompany$billi9, _currentCompany$billi0, _currentCompany$billi1, _property$buildingInf, _currentCompany$billi10, _currentCompany$billi11;
  const classes = useStyles();
  const store = useStore();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const parentRef = useRef(null);
  const currentCompany = store.homeDashboardStore.getCurrentCompany || {};
  const billingTab = currentCompany.billingTab;
  const isAllPropertiesMode = store.homeDashboardStore.selectedPropertyId === 'all';
  const statusesTexts = _objectSpread({
    all: {
      label: t('general.all')
    }
  }, billStatuses(t));
  const allocationBatchId = billingTab.allocationBatchId;
  const applyBill = billingTab.applyBill || {};
  const property = isAllPropertiesMode ? store.homeDashboardStore.getPropertyById(applyBill.propertyId) || {} : store.homeDashboardStore.getCurrentProperty || {};
  const billingCycleId = applyBill.billingCycleId;
  const billingSummary = (_property$allocations = property.allocations) === null || _property$allocations === void 0 ? void 0 : _property$allocations.billingSummary;
  const dateRange = toJS(isAllPropertiesMode ? billingTab === null || billingTab === void 0 ? void 0 : billingTab.dateRange : property === null || property === void 0 || (_property$allocations2 = property.allocations) === null || _property$allocations2 === void 0 ? void 0 : _property$allocations2.dateRange);
  const filterStatuses = isAllPropertiesMode ? billingTab === null || billingTab === void 0 ? void 0 : billingTab.filterStatuses : property === null || property === void 0 || (_property$allocations3 = property.allocations) === null || _property$allocations3 === void 0 ? void 0 : _property$allocations3.filterStatuses;
  // Every property, not the nav's filtered list: in all-properties mode the list shows each property's tables, and one
  // the nav's filters leave out still needs its address shown and searchable.
  // The first copy of a property in two portfolios, the one getPropertyById returns and Apply Billing reads.
  const propertiesObj = store.homeDashboardStore.getCurrentCompanyAllProperties.reduce((acc, p) => {
    if (!acc[p.id]) acc[p.id] = p;
    return acc;
  }, {});
  const propertyId = property.id;
  const previewQueue = billingTab.previewQueue;
  const setApplyBillAutosave = billingTab.setApplyBillAutosave;
  const setStatus = isAllPropertiesMode ? billingTab === null || billingTab === void 0 ? void 0 : billingTab.setStatus : property === null || property === void 0 || (_property$allocations4 = property.allocations) === null || _property$allocations4 === void 0 ? void 0 : _property$allocations4.setStatus;
  const setDateRange = isAllPropertiesMode ? billingTab === null || billingTab === void 0 ? void 0 : billingTab.setDateRange : property === null || property === void 0 || (_property$allocations5 = property.allocations) === null || _property$allocations5 === void 0 ? void 0 : _property$allocations5.setDateRange;
  const status = isAllPropertiesMode ? billingTab === null || billingTab === void 0 ? void 0 : billingTab.status : property === null || property === void 0 || (_property$allocations6 = property.allocations) === null || _property$allocations6 === void 0 ? void 0 : _property$allocations6.status;
  const summaries = isAllPropertiesMode ? billingTab === null || billingTab === void 0 ? void 0 : billingTab.billingSummary : billingSummary;
  const _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isLoading = _useState2[0],
    setIsLoading = _useState2[1];
  const _useState3 = useState(''),
    _useState4 = _slicedToArray(_useState3, 2),
    searchText = _useState4[0],
    setSearchText = _useState4[1];
  const getAllocationComparison = async data => {
    const resp = await store.allocations.getAllocationComparisonAsync.run(data);
    return resp;
  };
  const getAllocationHistory = async data => {
    const resp = await store.allocations.getAllocationHistoryAsync.run({
      data,
      applyToHomeDashboard: true
    });
    return resp;
  };
  const getFilesInfo = async data => {
    const resp = await store.files.getFilesInfoAsync.run(data);
    return resp;
  };
  const getUtilityInfo = async ids => {
    const resp = await store.utilityProviders.getUtilityInfoAsync.run({
      utilityIds: ids
    });
    return resp;
  };
  const getPropertyUtilityProviders = async data => {
    const resp = await store.properties.getPropertyUtilityProvidersV3Async.run(data);
    return resp;
  };
  const getAllocationPreview = async data => {
    var _resp$response, _resp$response2;
    const resp = await store.allocations.getAllocationPreviewAsync.run(data);
    const promises = [];
    const fileIds = resp === null || resp === void 0 || (_resp$response = resp.response) === null || _resp$response === void 0 || (_resp$response = _resp$response.utilityTables) === null || _resp$response === void 0 ? void 0 : _resp$response.map(u => u.redactedFileId ? u.redactedFileId : u.fileId).filter(Boolean);
    if ((fileIds === null || fileIds === void 0 ? void 0 : fileIds.length) > 0) promises.push(getFilesInfo({
      fileIds
    }));
    const utilityIds = resp === null || resp === void 0 || (_resp$response2 = resp.response) === null || _resp$response2 === void 0 || (_resp$response2 = _resp$response2.utilityTables) === null || _resp$response2 === void 0 ? void 0 : _resp$response2.map(u => u.utilityId);
    if ((utilityIds === null || utilityIds === void 0 ? void 0 : utilityIds.length) > 0) promises.push(getUtilityInfo(utilityIds));
    if (propertyId) promises.push(getPropertyUtilityProviders({
      propertyId
    }));
    await Promise.all(promises);
    return resp;
  };
  const getAllocationTable = async data => {
    const resp = await store.allocations.getAllocationTableAggregateAsync.run(data);
    return resp;
  };
  const getBillingSummary = async data => {
    const resp = await store.allocations.getBillingSummaryAsync.run(data);
    return resp;
  };
  const getCurrentCycle = async data => {
    const resp = await store.allocations.getCurrentCycleAsync.run(_objectSpread({
      applyToHomeDashboard: true
    }, data));
    return resp;
  };
  const sortSummaries = (mode, s) => mode === 'all' ? s === null || s === void 0 ? void 0 : s.map(item => {
    var _monthNames, _item$statuses;
    return _objectSpread(_objectSpread({}, item), {}, {
      cycleName: ((_monthNames = monthNames[item.month - 1]) === null || _monthNames === void 0 ? void 0 : _monthNames.substring(0, 3)) + ' ' + item.year,
      cycleUtilityTableStatuses: (_item$statuses = item.statuses) === null || _item$statuses === void 0 ? void 0 : _item$statuses.map(u => {
        var _statusesTexts$u$bill;
        return (_statusesTexts$u$bill = statusesTexts[u.billStatus]) === null || _statusesTexts$u$bill === void 0 ? void 0 : _statusesTexts$u$bill.label;
      }).toString(),
      prId: BigInt('0x' + item.propertyId.replace(/-/g, '')).toString()
    });
  }).sort((a, b) => {
    if (b.prId === a.prId) return b.isDefaultBillingCycle - a.isDefaultBillingCycle;else return b.prId - a.prId;
  }) : s === null || s === void 0 ? void 0 : s.map(item => {
    var _monthNames2, _item$statuses2;
    return _objectSpread(_objectSpread({}, item), {}, {
      cycleName: ((_monthNames2 = monthNames[item.month - 1]) === null || _monthNames2 === void 0 ? void 0 : _monthNames2.substring(0, 3)) + ' ' + item.year,
      cycleUtilityTableStatuses: item.isCurrentAllocationCycle ? (_item$statuses2 = item.statuses) === null || _item$statuses2 === void 0 ? void 0 : _item$statuses2.map(u => {
        var _statusesTexts$u$bill2;
        return (_statusesTexts$u$bill2 = statusesTexts[u.billStatus]) === null || _statusesTexts$u$bill2 === void 0 ? void 0 : _statusesTexts$u$bill2.label;
      }).toString() : t('allocations.sent_out')
    });
  }).sort((a, b) => {
    if (b.year === a.year && b.month === a.month) return b.isDefaultBillingCycle - a.isDefaultBillingCycle;else if (b.year === a.year) return b.month - a.month;else return b.year - a.year;
  });
  const getSummary = (params, mode) => {
    const isAllMode = mode === 'all';
    return getBillingSummary(_objectSpread({}, params)).then(resp => {
      const sorted = sortSummaries(mode, resp === null || resp === void 0 ? void 0 : resp.response);
      const statuses = sorted === null || sorted === void 0 ? void 0 : sorted.map(item => item.statuses).flat();
      const uniqueStatuses = [...new Set(statuses === null || statuses === void 0 ? void 0 : statuses.map(item => item.billStatus))];
      if (isAllMode) {
        billingTab.setBillingSummaryAfteFetch(sorted);
        if (status === 'all') billingTab.setFilterStatuses(['all', ...uniqueStatuses]);
      } else {
        var _sorted$, _sorted$2, _sorted, _sorted2;
        property.allocations.setBillingSummaryAfteFetch(sorted);
        property.allocations.setFilterStatuses(['all', ...uniqueStatuses]);
        const endDateOnly = "".concat(sorted === null || sorted === void 0 || (_sorted$ = sorted[0]) === null || _sorted$ === void 0 ? void 0 : _sorted$.year).concat(sorted === null || sorted === void 0 || (_sorted$2 = sorted[0]) === null || _sorted$2 === void 0 ? void 0 : _sorted$2.month.toString().padStart(2, '0')) * 1;
        const startDateOnly = "".concat(sorted === null || sorted === void 0 || (_sorted = sorted[(sorted === null || sorted === void 0 ? void 0 : sorted.length) - 1]) === null || _sorted === void 0 ? void 0 : _sorted.year).concat(sorted === null || sorted === void 0 || (_sorted2 = sorted[(sorted === null || sorted === void 0 ? void 0 : sorted.length) - 1]) === null || _sorted2 === void 0 ? void 0 : _sorted2.month.toString().padStart(2, '0')) * 1;
        setDateRange({
          startDateOnly,
          endDateOnly
        });
      }
      const residentAccountIds = [];
      resp === null || resp === void 0 || resp.response.forEach(item => {
        const propertyData = store.homeDashboardStore.getPropertyById(item.propertyId);
        if (!propertyData) return;
        if (item.cycleChargesPreview.length > 0) {
          var _propertyData$allocat;
          (_propertyData$allocat = propertyData.allocations) === null || _propertyData$allocat === void 0 || _propertyData$allocat.setChargesPreviewAfterFetch(item.allocationCycleId + item.propertyId, [...item.cycleChargesPreview].sort((a, b) => a.unitName.localeCompare(b.unitName)));
          item.cycleChargesPreview.forEach(i => {
            if (i.residentAccountId) residentAccountIds.push(i.residentAccountId);
          });
        }
        const accountIds = [...new Set(residentAccountIds)];
        return store.account.getUsersProfilesAsync.run({
          accountIds
        });
      });
    });
  };
  const activeBatchUtilityIdRef = useRef(null);
  useEffect(() => {
    if (allocationBatchId) {
      activeBatchUtilityIdRef.current = applyBill.utilityId;
    }
  }, [allocationBatchId]);
  const getLiveBatchApplyBill = () => {
    const live = billingTab.applyBill;
    if (!(live !== null && live !== void 0 && live.utilityId) || live.utilityId !== activeBatchUtilityIdRef.current) return null;
    if (live.billingCycleId !== billingCycleId) return null;
    if (live.propertyId && live.propertyId !== propertyId) return null;
    return live;
  };
  useBatch(allocationBatchId, async () => {
    if (!billingCycleId || !propertyId) return;
    const refreshSummaryAndPreview = () => Promise.resolve(billingTab.updateBillingSummaryTimestamp()).then(() => {
      var _store$homeDashboardS;
      return billingTab.addToPreviewQueue({
        billingCycleId,
        id: billingCycleId + propertyId,
        portfolioId: ((_store$homeDashboardS = store.homeDashboardStore.getCurrentPortfolio) === null || _store$homeDashboardS === void 0 ? void 0 : _store$homeDashboardS.id) || '',
        propertyId
      });
    });
    const live = getLiveBatchApplyBill();
    if (!live) return refreshSummaryAndPreview();
    billingTab.setIsModalLoading(true);
    return getAllocationTable({
      billingCycleId,
      propertyId,
      utilityId: live.utilityId
    }).then(() => getAllocationComparison({
      billingCycleId,
      propertyId,
      utilityId: live.utilityId
    })).then(refreshSummaryAndPreview).finally(() => currentCompany.billingTab.setIsModalLoading(false));
  }, () => {}, function () {
    var _property$allocations7;
    let _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$timedOut = _ref.timedOut,
      timedOut = _ref$timedOut === void 0 ? false : _ref$timedOut;
    const live = getLiveBatchApplyBill();
    if (!live) return;
    // Calculate allocation turned the modal loader on and relies on this handler to turn it off.
    if (timedOut) {
      billingTab.setIsModalLoading(false);
      return;
    }
    const currentStatus = live.status;
    if (currentStatus === 'TableReady' || currentStatus === 'TableReadyStatementSent') return;
    const refreshed = (_property$allocations7 = property.allocations) === null || _property$allocations7 === void 0 ? void 0 : _property$allocations7.utilityById.get(billingCycleId + live.utilityId);
    if (currentStatus === 'TableSkipped' && reloadedStatus(refreshed) === 'TableSkipped') return;
    billingTab.setIsModalLoading(true);
    billingTab.setApplyBill(_objectSpread(_objectSpread({}, live), {}, {
      propertyId,
      status: 'PendingApproval'
    }));
    setApplyBillAutosave(true);
    setTimeout(() => setApplyBillAutosave(false), 2000);
    billingTab.setIsModalLoading(false);
  }, t('allocations.table_fetch_error'),
  // The id comes from the table read and can be a batch the activity service no longer knows.
  {
    silentWhenUnknown: true
  });
  useEffect(() => {
    if (property.id) {
      getAllocationHistory({
        endMonth: 12,
        endYear: moment().endOf('month').year(),
        startMonth: 1,
        startYear: 1970,
        propertyId
      });
    }
    if (property.id) {
      billingTab.setAllocationCycleIsLoadingById(applyBill.allocationCycleId + property.id, true);
      if (!isAllPropertiesMode) setIsLoading(true);
      getSummary({
        fromDateOnly: null,
        propertyIds: [property.id],
        statuses: [],
        toDateOnly: null
      }).then(() => getCurrentCycle({
        companyId: currentCompany.id
      })).finally(() => setIsLoading(false));
    } else if (isAllPropertiesMode) {
      setIsLoading(true);
      getCurrentCycle({
        companyId: currentCompany.id
      }).then(() => getSummary({
        allocationCycleId: store.allocations.currentCycle.id,
        fromDateOnly: null,
        propertyIds: [],
        statuses: [],
        toDateOnly: null
      }, 'all')).finally(() => setIsLoading(false));
    }
  }, [property.id]);
  useEffect(() => {
    if (billingTab.billingSummaryTimestamp) {
      const params = {
        fromDateOnly: null,
        propertyIds: [property.id],
        statuses: [],
        toDateOnly: null
      };
      if (isAllPropertiesMode) {
        params.allocationCycleId = store.allocations.currentCycle.id;
        params.propertyIds = [];
      }
      getSummary(_objectSpread({}, params), isAllPropertiesMode ? 'all' : 'set');
    }
  }, [billingTab.billingSummaryTimestamp]);
  useEffect(() => {
    if (previewQueue.length > 0 && !store.allocations.getAllocationPreviewAsync.inProgress) getAllocationPreview({
      billingCycleId: previewQueue[0].billingCycleId,
      portfolioId: previewQueue[0].portfolioId,
      propertyId: previewQueue[0].propertyId
    }).finally(() => {
      let queue = [...previewQueue];
      const executed = queue.shift();
      queue = queue.map(i => i.allocationCycleId);
      if (!queue.includes(executed.allocationCycleId)) billingTab.setAllocationCycleIsLoadingById(executed.allocationCycleId + executed.propertyId, false);
      billingTab.removeFromPreviewQueue(executed);
    });
  }, [previewQueue]);
  const filter = i => {
    const search = searchText === null || searchText === void 0 ? void 0 : searchText.toLowerCase();
    return i.cycleName.toLowerCase().includes(search) || i.cycleUtilityTableStatuses.toLowerCase().includes(search);
  };
  const filterForAll = i => {
    var _propertiesObj$i$prop;
    const search = searchText === null || searchText === void 0 ? void 0 : searchText.toLowerCase();
    return i.cycleUtilityTableStatuses.toLowerCase().includes(search) || ((_propertiesObj$i$prop = propertiesObj[i.propertyId]) === null || _propertiesObj$i$prop === void 0 || (_propertiesObj$i$prop = _propertiesObj$i$prop.dashboard.propertyAddress) === null || _propertiesObj$i$prop === void 0 ? void 0 : _propertiesObj$i$prop.toLowerCase().includes(search));
  };
  const getDate = date => date ? moment(date, 'YYYYMM').toDate() : undefined;
  const handleDateChange = async (fromDate, toDate) => {
    const date = {
      startDateOnly: fromDate ? moment(fromDate).format('YYYYMM') * 1 : null,
      endDateOnly: toDate ? moment(toDate).format('YYYYMM') * 1 : null
    };
    setDateRange(date);
    if (fromDate && toDate) getSummary({
      fromDateOnly: formatISO(fromDate).split('T')[0],
      propertyIds: [property.id],
      statuses: [],
      toDateOnly: formatISO(toDate).split('T')[0]
    }, isAllPropertiesMode ? 'all' : 'set');
  };
  const handleStatusChange = async e => {
    const newStatus = e.target.value;
    setStatus(newStatus);
    const startDateOnly = dateRange.startDateOnly,
      endDateOnly = dateRange.endDateOnly;
    const data = {
      fromDateOnly: startDateOnly && newStatus !== 'all' ? formatISO(moment(startDateOnly, 'YYYYMM').toDate()).split('T')[0] : null,
      propertyIds: isAllPropertiesMode ? [] : [property.id],
      statuses: newStatus === 'all' ? [] : [newStatus],
      toDateOnly: endDateOnly && newStatus !== 'all' ? formatISO(moment(endDateOnly, 'YYYYMM').toDate()).split('T')[0] : null
    };
    if (isAllPropertiesMode && newStatus === 'all') data.allocationCycleId = store.allocations.currentCycle.id;
    getSummary(_objectSpread({}, data), isAllPropertiesMode ? 'all' : 'set');
  };
  const filteredBillings = summaries === null || summaries === void 0 ? void 0 : summaries.filter(isAllPropertiesMode ? filterForAll : filter);
  const rowVirtualizer = useVirtualizer({
    count: (_filteredBillings$len = filteredBillings === null || filteredBillings === void 0 ? void 0 : filteredBillings.length) !== null && _filteredBillings$len !== void 0 ? _filteredBillings$len : 0,
    getScrollElement: () => parentRef.current,
    estimateSize: () => 74,
    overscan: 5
  });
  return /*#__PURE__*/React.createElement(Paper, {
    className: classes.billings
  }, /*#__PURE__*/React.createElement(AddCustomBilling, null), /*#__PURE__*/React.createElement(ApplyBillingFull, {
    property: property
  }), /*#__PURE__*/React.createElement(PreviewCycleChargesModal, null), /*#__PURE__*/React.createElement(SkipBillModal, null), /*#__PURE__*/React.createElement(SubmeterBillModal
  // property,
  , {
    billTabStoreObject: currentCompany.billingTab,
    submeterFinalStateInfo: (_currentCompany$billi = (_currentCompany$billi2 = currentCompany.billingTab) === null || _currentCompany$billi2 === void 0 || (_currentCompany$billi2 = _currentCompany$billi2.submeterBill) === null || _currentCompany$billi2 === void 0 ? void 0 : _currentCompany$billi2.submeterBillFinalStateData) !== null && _currentCompany$billi !== void 0 ? _currentCompany$billi : null,
    isOpen: (_currentCompany$billi3 = currentCompany.billingTab) === null || _currentCompany$billi3 === void 0 ? void 0 : _currentCompany$billi3.isSubmeterBillModalOpen,
    handleChangeIsOpen: v => {
      var _currentCompany$billi4;
      return (_currentCompany$billi4 = currentCompany.billingTab) === null || _currentCompany$billi4 === void 0 ? void 0 : _currentCompany$billi4.setSubmeterBillModalOpenState(v);
    },
    propertyAddress: (_currentCompany$billi5 = currentCompany.billingTab) === null || _currentCompany$billi5 === void 0 ? void 0 : _currentCompany$billi5.submeterBill.buildingAddress,
    utilityName: (_currentCompany$billi6 = currentCompany.billingTab) === null || _currentCompany$billi6 === void 0 || (_currentCompany$billi6 = _currentCompany$billi6.submeterBill) === null || _currentCompany$billi6 === void 0 ? void 0 : _currentCompany$billi6.utilityName,
    utilityId: (_currentCompany$billi7 = currentCompany.billingTab) === null || _currentCompany$billi7 === void 0 || (_currentCompany$billi7 = _currentCompany$billi7.submeterBill) === null || _currentCompany$billi7 === void 0 ? void 0 : _currentCompany$billi7.utilityId,
    cycleName: (_currentCompany$billi8 = currentCompany.billingTab) === null || _currentCompany$billi8 === void 0 || (_currentCompany$billi8 = _currentCompany$billi8.submeterBill) === null || _currentCompany$billi8 === void 0 ? void 0 : _currentCompany$billi8.cycleName,
    status: 'sent',
    allocationMethod: 'Submeter',
    isPreviewOnly: ((_currentCompany$billi9 = currentCompany.billingTab) === null || _currentCompany$billi9 === void 0 || (_currentCompany$billi9 = _currentCompany$billi9.submeterBill) === null || _currentCompany$billi9 === void 0 ? void 0 : _currentCompany$billi9.submeterBillFinalStateData) !== null && ((_currentCompany$billi0 = currentCompany.billingTab) === null || _currentCompany$billi0 === void 0 || (_currentCompany$billi0 = _currentCompany$billi0.submeterBill) === null || _currentCompany$billi0 === void 0 || (_currentCompany$billi0 = _currentCompany$billi0.submeterBillFinalStateData) === null || _currentCompany$billi0 === void 0 ? void 0 : _currentCompany$billi0.length) > 0,
    propertyId: (_currentCompany$billi1 = currentCompany.billingTab) === null || _currentCompany$billi1 === void 0 || (_currentCompany$billi1 = _currentCompany$billi1.submeterBill) === null || _currentCompany$billi1 === void 0 ? void 0 : _currentCompany$billi1.propertyId,
    buildingId: property === null || property === void 0 || (_property$buildingInf = property.buildingInformation) === null || _property$buildingInf === void 0 ? void 0 : _property$buildingInf.id,
    allocationCycleId: (_currentCompany$billi10 = currentCompany.billingTab) === null || _currentCompany$billi10 === void 0 || (_currentCompany$billi10 = _currentCompany$billi10.submeterBill) === null || _currentCompany$billi10 === void 0 ? void 0 : _currentCompany$billi10.allocationCycleId,
    billingCycleId: (_currentCompany$billi11 = currentCompany.billingTab) === null || _currentCompany$billi11 === void 0 || (_currentCompany$billi11 = _currentCompany$billi11.submeterBill) === null || _currentCompany$billi11 === void 0 ? void 0 : _currentCompany$billi11.billingCycleId
  }), /*#__PURE__*/React.createElement("div", {
    className: classes.allocationBodySettings
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.allocationBodySearch
  }, /*#__PURE__*/React.createElement(InputWithIcon, {
    icon: /*#__PURE__*/React.createElement(Icon, {
      type: "search"
    })
  }, /*#__PURE__*/React.createElement(TextField, {
    fullWidth: true,
    onChange: e => setSearchText(e.target.value),
    placeholder: isAllPropertiesMode ? 'Search by address, cycle status' : 'Search by cycle name, cycle status and utilities statuses',
    variant: "outlined",
    size: "small"
  }))), /*#__PURE__*/React.createElement("div", {
    className: classes.allocationBodyStatusFilter
  }, /*#__PURE__*/React.createElement(SelectMenu, {
    label: "Status",
    labelId: "status-selector-label",
    onChange: handleStatusChange,
    value: status
  }, filterStatuses === null || filterStatuses === void 0 ? void 0 : filterStatuses.map((s, i) => /*#__PURE__*/React.createElement(MenuItem, {
    key: i,
    value: s
  }, statusesTexts[s].label)))), isAllPropertiesMode ? null : /*#__PURE__*/React.createElement(MonthRangeDatePicker, {
    disabled: isLoading,
    format: 'MM/yyyy',
    fromDateExternal: getDate(dateRange === null || dateRange === void 0 ? void 0 : dateRange.startDateOnly),
    handleDateChange: (fromDate, toDate) => handleDateChange(fromDate, toDate, true),
    label: 'all' === 'all' ? t('reimbursement_dashboard.period_whole_time') : undefined,
    toDateExternal: getDate(dateRange === null || dateRange === void 0 ? void 0 : dateRange.endDateOnly)
  })), /*#__PURE__*/React.createElement(BackdropLoader, {
    isOpen: isLoading
  }), (filteredBillings === null || filteredBillings === void 0 ? void 0 : filteredBillings.length) === 0 && !isLoading ? /*#__PURE__*/React.createElement("div", {
    className: classes.noUtilitiesHint
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h5",
    color: "light"
  }, t('allocations.this_property_does_not_have_any_utility'))) : null, (filteredBillings === null || filteredBillings === void 0 ? void 0 : filteredBillings.length) > 0 ? /*#__PURE__*/React.createElement("div", {
    ref: parentRef,
    style: {
      height: 'calc(100vh - 278px)',
      overflow: 'auto'
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      height: "".concat(rowVirtualizer.getTotalSize(), "px"),
      position: 'relative',
      width: '100%'
    }
  }, rowVirtualizer.getVirtualItems().map(virtualRow => {
    const summary = filteredBillings[virtualRow.index];
    const key = "".concat(summary.allocationCycleId, "-").concat(summary.propertyId);
    return /*#__PURE__*/React.createElement("div", {
      key: key,
      ref: rowVirtualizer.measureElement,
      "data-index": virtualRow.index,
      style: {
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        transform: "translateY(".concat(virtualRow.start, "px)")
      }
    }, /*#__PURE__*/React.createElement(Billing, {
      propertiesObj: propertiesObj,
      summary: summary,
      defaultExpanded: !isAllPropertiesMode && virtualRow.index === 0
    }));
  }))) : null);
});
export default BillingTab;